import React, { memo } from "react";

import { SkeletonList } from "@hl/base-components/lib/Skeleton";
import useMantineMediaQueries from "@hl/base-components/lib/hooks/useMantineMediaQueries";
import {
  Group,
  Stack,
  useMantineTheme,
  Skeleton,
  AppShell,
  Flex,
} from "@mantine/core";

import MarketplaceFooterSkeleton from "~features/MintPage/apollo/skeleton/MarketplaceFooterSkeleton";
import { AppHeader } from "~features/layout/Header";
import MarketplacePageSkeletonApollo from "~features/marketplace/skeleton/MarketplacePageSkeletonApollo";

const MintPageApolloSkeleton = () => {
  const theme = useMantineTheme();
  const { isMedium, isSmall, isMobile } = useMantineMediaQueries({
    withInitialValues: true,
  });

  return (
    <AppShell
      header={<AppHeader />}
      styles={{
        main: { paddingTop: "calc(var(--mantine-header-height, 0px))" },
      }}
    >
      <Stack
        align="center"
        sx={{
          borderTop: `1px solid ${theme.colors.divider[0]}`,
          borderBottom: `1px solid ${theme.colors.divider[0]}`,
        }}
        mx={isSmall ? -20 : -16}
        py="xs"
      >
        <Stack
          px={isMedium ? 40 : 20}
          w="100%"
          justify="space-between"
          py={isMobile ? 16 : 32}
          sx={{ overflow: "hidden" }}
          spacing="xs"
        >
          <Flex
            gap="xs"
            direction={isMobile ? "column" : "row"}
            align={isMobile ? "start" : "center"}
          >
            <Skeleton h={80} w={80} />
            <Stack spacing={8}>
              <Skeleton height={29} width={220} />
              <Group spacing="xs">
                <Skeleton width={16} height={16} radius={99} />
                <Skeleton height={14} width={90} />
              </Group>
            </Stack>
          </Flex>
          <Group>
            <Skeleton width="50%" height={14} />
            <Skeleton width={72} height={14} />
          </Group>
          <Stack w="100%" sx={{ overflow: "hidden" }} align="start">
            <MarketplaceFooterSkeleton isScrollable={true} />
            <Group noWrap>
              <SkeletonList
                count={7}
                skeleton={<Skeleton height={14} width={48} />}
              />
            </Group>
          </Stack>
        </Stack>
      </Stack>
      <MarketplacePageSkeletonApollo />
    </AppShell>
  );
};

export default memo(MintPageApolloSkeleton);
